// services/Deliverable.js
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";
import api from "../../system/api";

export default class Task extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "task";
    static pluralName = "tasks";
    static displayName = "Task";

    constructor() {
        super(`${Task.kind}`,`${Task.singularName}`,`${Task.pluralName}`);}

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query);
    }


    async getById(id, query = {}) {
        return await this.find(id, { populate: "*", ...query });
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data) {
        return await this.update(id, data);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }

    // Recurring tasks: DELETE /tasks/:id?scope=this|following|all
    async deleteWithScope(id, scope = "this") {
        const url = `/${this.pluralName}/${id}`;
        try {
            await this.waitForWorkspace();
            const res = await api.delete(url, {params: {scope}, ...this.getHeader()});
            return res.data;
        } catch (err) {
            throw this._normalizeError(err);
        }
    }

    // Recurring tasks: skip / unskip one occurrence
    async skip(id, reason = null) {
        return await this.postAction(`/tasks/${id}/skip`, {reason});
    }

    async unskip(id) {
        return await this.postAction(`/tasks/${id}/unskip`, {});
    }
}
